export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_INWEBO = 'LOGIN_INWEBO';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const CHECK_END = 'CHECK_END';
export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const API_ERROR = 'LOGIN_API_ERROR';
